/**
 * Requires
 */

import $ from 'jquery'
import 'slick-carousel'

/**
 * Variables
 */

const $slides = $('[data-header-slides]')
const previous =
  '<button type="button" data-role="none" class="slide-control previous hidden-small-down" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg></button>'
const next =
  '<button type="button" data-role="none" class="slide-control next hidden-small-down" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg></button>'

/**
 * Initialisation
 */

export function init() {
  $slides.each(function () {
    const $container = $(this)
    const config = $container.data('header-slides')

    $container
      .on('init', function (event, slick) {
        $container.find('.page-header').on('click', (event) => {
          if (!$(event.target).hasClass('button')) slick.slickNext()
        })
        $container.find('.page-header video').each((i, elem) => elem.play())
      })
      .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $container.addClass('transitioning')
      })
      .on('afterChange', function (event, slick, breakpoint) {
        setTimeout(() => $container.removeClass('transitioning'), 300)
        $container.find('.page-header video').each((i, elem) => elem.play())
      })
      .slick({
        speed: 500,
        fade: true,
        infinite: true,
        cssEase: 'cubic-bezier(1.000, 0.005, 1.000, 0.000)',
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5500,
        prevArrow: previous,
        nextArrow: next,
      })
  })
}
